<template>
	<div class="container-fluid">
		<h1 class="mb-3">{{ $t("osce") }}</h1>
		<div class="row">
			<div class="col-md-6">
				<div
					v-if="hasPriv('OSCE_ADMIN')"
					@click="$router.push('/osce/admin')"
					class="list-group border-radius-2 no-border mb-3 shadow-sm"
					style="cursor:pointer;"
				>
					<div class="list-group-item list-group-header">
						<h3>{{ $t('admin-view') }}</h3>
						<p class="mb-0">{{ $t('admin-view') }}</p>
					</div>
				</div>

                <div
					v-if="hasPriv('OSCE_FORM_APPROVE') || hasPriv('OSCE_QA') || hasPriv('OSCE_OBSERVER') || hasPriv('OSCE_EXAMINER')"
					@click="$router.push('/osce/examiner')"
					class="list-group border-radius-2 no-border mb-3 shadow-sm"
					style="cursor:pointer;"
                >
					<div class="list-group-item list-group-header">
						<h3>{{ $t('examiner-view') }}</h3>
						<p class="mb-0">{{ $t('examiner-view') }}</p>
					</div>
				</div>
			
			</div>


		</div>

		

	</div>
</template>

<script>
export default {
	components: {
		
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	methods: {
		hasPriv(priv) {
			return this.$UserSession.hasPriv.call(this, priv);
		}
	}
};
</script>